"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.getReducer = void 0;
var react_1 = __importDefault(require("react"));
var constants_1 = require("./constants");
// Initial state
var initialState = {
    statusBarData: {
        active: false,
        fileName: '',
        fileSize: constants_1.DEFAULT_FILE_SIZE,
    },
    downloadInitiated: false,
    disableUpload: false,
    uploadStatus: constants_1.STATUS_TYPES.NOT_STARTED,
};
var reducer = function (state, action) {
    switch (action.type) {
        case constants_1.REDUCER_ACTIONS.SET_STATUS_BAR_DATA:
            return __assign(__assign({}, state), { statusBarData: action.data.statusBarData });
        case constants_1.REDUCER_ACTIONS.SET_DOWNLOAD_INITIATED:
            return __assign(__assign({}, state), { downloadInitiated: action.data.downloadInitiated });
        case constants_1.REDUCER_ACTIONS.SET_DISABLE_UPLOAD:
            return __assign(__assign({}, state), { disableUpload: action.data.disableUpload });
        case constants_1.REDUCER_ACTIONS.SET_UPLOAD_STATUS:
            return __assign(__assign({}, state), { uploadStatus: action.data.uploadStatus });
        default:
            return state;
    }
};
// eslint-disable-next-line import/prefer-default-export
exports.getReducer = function () {
    // TODO - Find an alternative to returning useReducer
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return react_1["default"].useReducer(reducer, initialState);
};
